import event from '../../../utils/analytics/event';
export var addScript = function addScript(appId) {
  if (typeof window === 'undefined' || window.pAsyncInit) {
    return;
  }

  window.pAsyncInit = function () {
    // eslint-disable-next-line
    PDK.init({
      appId: appId,
      cookie: true
    });
  };

  var script = document.createElement('script');
  script.src = '//assets.pinterest.com/js/pinit.js';
  script.async = true;
  document.body.appendChild(script);
};
/**
 * Custom hook which loads the Pinterest SDK automatically and provides pinterest sharing functionality anywhere within the app.
 *
 * By default, it logs 1 piwik event: `event(['share', 'pinterest', <PAGE_BEING_SHARED>]);`, but you can pass in a custom `piwikEvent` to log instead.
 *
 * This event is logged when the user begins to share with pinterest. If choosing to continue with the default piwik events provided, a value must be provided for the `page` prop.
 *
 * If a value is passed for the `piwikEvent` prop, then the button onClick will log that custom event instead.
 *
 * ```js
 * import { usePinterestShare } from '@minerva-analytics/pantheon';
 *
 * // Without custom piwik event
 * const Test = () => {
 *   const pinterestShare = usePinterestShare({
 *     url: 'https://url.com',
 *     description: 'example description',
 *     appId: '12345678',
 *     page: 'example-page'
 *   });
 *
 *   return <button onClick={() => pinterestShare()}>Pintrest Button</button>;
 * }
 *
 * // With custom piwik event
 * const Test = () => {
 *   const pinterestShare = usePinterestShare({
 *     url: 'https://url.com',
 *     description: 'example description',
 *     appId: '12345678',
 *     piwikEvent: ['click', 'pinterest-share']

 *   });
 *
 *   return <button onClick={() => pinterestShare()}>Pinterest Button</button>;
 * }
 * ```
 *
 * @param {object} options - Options for the hook
 * @param {string} options.url - URL that user is intending to share
 * @param {string} options.description - Custom description for share
 * @param {string} options.media - Custom image for share
 * @param {string} options.appId - Pinterest app ID
 * @param {string} options.page - The page that this hook will be used on. This is used for creating unique piwik events per page.
 * @param {array} options.piwikEvent - Optional custom event that is logged upon sharing with pinterest. Must be an array in the form of `[category, action, name, value]`, though `name` and `value` are optional.
 *
 * @returns {function} -  Function that allows user to share with Pinterest
 */

var usePinterestShare = function usePinterestShare(_ref) {
  var url = _ref.url,
      description = _ref.description,
      media = _ref.media,
      page = _ref.page,
      appId = _ref.appId,
      _ref$piwikEvent = _ref.piwikEvent,
      piwikEvent = _ref$piwikEvent === void 0 ? null : _ref$piwikEvent;
  addScript(appId);

  var share = function share() {
    // eslint-disable-next-line
    if (!PinUtils) {
      setTimeout(function () {
        return share();
      }, 1000); // retriggering share() after 1 second if PinUtils does not exist

      return;
    }

    event(piwikEvent || ['share', 'pinterest', page]); // eslint-disable-next-line

    PinUtils.pinOne({
      media: media,
      url: url,
      description: description
    });
  };

  return share;
};

export default usePinterestShare;